import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AttestationDetailsService } from '../../../views/pages/das/components/attestation-details/services/attestation-details.service';
import { HecResponse } from '../../shared-interfaces/hecResponse';
import { HEC_CONSTANTS } from '../../../utilities/constants';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';

@Component({
  selector: 'kt-das-update-case',
  templateUrl: './das-update-case.component.html',
  styleUrls: ['./das-update-case.component.css']
})
export class DasUpdateCaseComponent implements OnInit {
  public verifiedCase:boolean =false;
  public updateCase:boolean =false;
  public degreeStatus:number;
  public duplicateStatus:number;
  public updateDegreeStatus:number;
  public duplicateCase:boolean = false;;
  public degreeAttestationForm: FormGroup;
  public isError: boolean;
  public alertType: string;
  public errorMsg: string;
  constructor(private dialogRef: MatDialogRef<DasUpdateCaseComponent>,@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  private attestationService:AttestationDetailsService,private fb: FormBuilder,) { }
  
  ngOnInit() {
    this.updateCase = this.data.updateCase;
    this.verifiedCase =this.data.verifiedCase
    this.createDegreeAttestationForm();
  }

  
  private createDegreeAttestationForm(): void {
    this.degreeAttestationForm = this.fb.group({
      isDegreeAttestedBefore:new FormControl(null),
      stampNumber:new FormControl(null),  
      isDegreeUpdateCase:new FormControl(null), 
      isDegreeDuplicateCase:new FormControl(null), 
  })
}

  public getDegreeStatus(e) {
    this.degreeStatus= e.value
    if(e.value == 0){
      this.dismiss('new')
    }   
  }

  public getDuplicateDegreeStatus(e){
    this.duplicateStatus = e.value
    if(e.value == 1){
      this.dismiss('duplicate')
    }else{
      this.dismiss('noDuplicate')
    }
  }

  public getUpdateDegreeStatus(e){
    this.updateDegreeStatus = e.value
    if(e.value == 0){
      this.dismiss('noUpdate')
    }else{
      this.dismiss('update')
    }
  }

  public validateStampNumber(i){
    let stampNumber = this.degreeAttestationForm.controls.stampNumber.value
   this.attestationService.validateStampNumber(stampNumber).subscribe(
      (res:HecResponse)=>{
        if(res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK){
          if(res.data){
            this.isError = false;
            // this.accept();
            this.duplicateCase = true;
          }else{
            this.degreeAttestationForm.controls.stampNumber.setErrors({max:true})
            this.isError = true;
            this.alertType = 'error';
            this.errorMsg = 'Incorrect Stamp Number' 
          }
        }
      }
    )
  }

  public accept() {
    this.dialogRef.close(true);
  }

  public dismiss(type) {
    this.dialogRef.close(type);
  }

}
